import authApi from "api/AuthApi";
import { activeProgress, disableProgress } from "./ProgressActionCreators";
import ToastCustom from "shared/components/ToastCustom";
import { LOCAL_STORAGE_TOKEN } from "shared/Constants";
import history from "core/helper/Helper";

export const fetchLoginRequest = (data) => {
  return (dispatch) => {
    dispatch(activeProgress());
    authApi
      .login(data)
      .then(
        (res) => {
          localStorage.setItem(LOCAL_STORAGE_TOKEN, res.body.token);
          history.goBack();
        },
        (err) => {
          ToastCustom.error("Tài khoảng không đúng. Vui lòng đăng nhập lại!");
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};
